import { useContext, useEffect, useState } from 'react';
import { FaFolderOpen } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import CardHeader from '../../antd/components/CardHeader';
import { AuthContext } from '../../Contexts/AuthContext';
import { CompanyContext } from '../../Contexts/CompanyContext';
import useCan from '../../Hooks/useCan';
import { PathsInFileManager } from '../../Static/PathsInFileManager';
import { InternalRoles } from '../../Static/Roles';

const FileManager = () => {
    const { roles } = useContext(AuthContext);
    const canSeeAll = useCan({ rolesCan: [ ...InternalRoles ] });
    const { company } = useContext(CompanyContext);
    const [ paths, setPaths ] = useState<any[]>([]);

    const getPaths = () => {
        if (canSeeAll) {
            setPaths(PathsInFileManager)
        } else {
            let pathsToUpper = roles.map(x => x.toUpperCase());
            let pathList = PathsInFileManager.filter(x => pathsToUpper.includes(x.id.toUpperCase()));

            if (roles.includes("Master")) {
                pathList = PathsInFileManager.filter(x => x.id !== "humanResources");
            } else if (roles.includes("TechnicianLimited") || roles.includes("Technician")) {
                pathList = [ PathsInFileManager[ 0 ] ];
            }

            setPaths(pathList);
        }
    }

    useEffect(() => {
        getPaths();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='card ml-2 mr-2'>
            <CardHeader
                pageName={"Gerenciador de Documentos"}
                hasPageBefore={false}
            />
            <div className='card-body'>
                <div className="row">
                    {paths.map((folder, index) => {
                        return (
                            <div className="col-md-3" key={index}>
                                <Link to={`/fileManager/pathManager/${company.id}/${folder.id}`}>
                                    <div className="card">
                                        <div className="card-header product-box">
                                            <div className="d-flex align-items-center justify-content-center pb-4 pt-4">
                                                <FaFolderOpen size={100} />
                                            </div>
                                        </div>
                                        <div className="card-body product-box">
                                            <label className="text-center w-100">{folder.name}</label>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default FileManager;